module.exports = __webpack_public_path__ + "img/welding-6.caa9acce.jpg";